import { SET_ANALYTICS_DATA } from "../types"

const initialState = {
    data: null,
}

const analyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ANALYTICS_DATA:
            return {
                ...state,
                data: action.payload,
            }

        default:
            return state
    }
}

export default analyticsReducer
